// extracted by mini-css-extract-plugin
module.exports = {"CoverSection2":"CoverSection2_CoverSection2__W_QHr"};